module.exports = __webpack_public_path__ + "img/logo-color.c715cb37.png";